import React, { useRef, useState } from "react";
import { Button } from "../components/Elements";
import Filters from "../components/OrderReports/Filters";
import ReportTable from "../components/OrderReports/ReportTable";
import PageTitle from "../components/PageTitle";
import { pageTitleTexts } from "../../constants/texts/pageTitleTexts";
import { buttonTexts } from "../../constants/texts/buttonTexts";
import { useSelector } from "react-redux";
import { exportExcelHelper } from "../../common/helpers/exportExcelHelper";
import { usePermissionCheck } from "../../hooks/usePermissionCheck";
import { UserOperationTypes } from "../../common/types/AuthorizationProps";

export default function OrderReport() {
  usePermissionCheck(UserOperationTypes["İşlem Listesi"], "Tahsilat Hareketlerini görüntüleme izni yok");
  const [filtersIsOpen, setFiltersIsOpen] = useState(true);
  const [tableDetail, setTableDetail] = useState(false);
  const [headCells, setHeadCells] = useState([]);
  const [excelLoading, setExcelLoading] = useState(false);

  const formFilterRef = useRef();
  const reportTableRef = useRef();

  const { reports } = useSelector((state) => state.orderReport);

  const handleShowDetailChange = (value) => {
    setTableDetail(value);
  }

  const exportToExcelClick = async () => {

    setExcelLoading(true);
    try {
      exportExcelHelper(reports, "id", reportTableRef, headCells, "Tahsilat_Hareketleri");
    } catch (error) {

    } finally {
      setExcelLoading(false);
    }
  }

  const handleHeadCells = (values) =>{
    setHeadCells(values);
  }

  return (
    <div className="w-full">
      <PageTitle title={pageTitleTexts.orderReport} />

      <div className="px-4 pt-2 flex flex-row items-center justify-between space-y-2">
        <div className="flex flex-row items-center">
          <img src={"/icons/islem-raporu-dark.svg"} className="h-6 w-6 black" />
          <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
            Tahsilat Hareketleri
          </span>
        </div>

        <div className=" flex flex-row justify-end items-center px-2">
          <Button
            size="xs"
            hover="gray"
            color="gray"
            callback={() => setFiltersIsOpen(!filtersIsOpen)}
          >
            <span className="mr-3">{buttonTexts.filterOpen}</span>
            <img src="/icons/filter.svg" alt="filter" />
          </Button>
        </div>
      </div>

      <Filters ref={formFilterRef} isOpen={filtersIsOpen} setFiltersIsOpen={setFiltersIsOpen} onShowDetailChange={handleShowDetailChange} />
      <div className="mr-4 flex justify-end">
        <Button
          color="primary"
          hover="primary"
          size="xs"
          callback={() => exportToExcelClick()}
          loading={excelLoading}
          disabled={excelLoading}
        >
          <img src="/icons/download.svg" alt="pushToExcel" />
          <span className='ml-3'>{buttonTexts.exportToExcel}</span>
        </Button>
      </div>
      <ReportTable formFilterRef={formFilterRef} showTableDetail={tableDetail} getHeadCells={handleHeadCells} reportTableRef={reportTableRef} />
    </div>
  );
}
